import { Decoration, DecorationSet } from 'prosemirror-view';

/**
 * Finds all the cursors for a given client ID in a set of decorations.
 * @param clientID The ID of the client whose cursors to find.
 * @param decorations The set of decorations to search for cursors.
 * @returns An array of decorations representing the cursors for the given client ID.
 */

export function findCursors(
  clientID: string,
  decorations: DecorationSet,
): Decoration[] {
  return decorations
    .find()
    .reduce(
      (arr, deco: Decoration) =>
        deco.spec.clientID === clientID ? arr.concat(deco) : arr,
      [] as Decoration[],
    );
}
